// @flow
import React, { useContext } from 'react';
import { PaddedAndRaisedSegment } from '@presentational/PaddedAndRaisedSegment';
import { GenericSaveResetButtons } from '@components/GenericSaveResetButtons';
import { Spacer } from '@presentational/spacing/Spacer';
import { Grid } from 'semantic-ui-react';
import { useParams } from 'react-router-dom';
import { SPStreamingProjectContext } from '@streaming-projects/sp-page/contexts/SPStreamingProjectContext';
import { useUpdateTableFlowWorkloadMutation } from '@streaming-projects/service-definitions/streamingProjectsApi';
import { SPRetentionContainer } from '@streaming-projects/workloads/cluster-workloads/workload-details/SPRetentionContainer';
import { RetentionApprovalRequiredContainer } from '@src/triggers/RetentionApprovalRequiredContainer';
import { SPRetentionInfiniteContainer } from '@streaming-projects/workloads/cluster-workloads/workload-details/SPRetentionInfiniteContainer';
import { FORM_NAMES } from '@streaming-projects/enums';
import { isAnythingEditedBesidesGivenFormBasedOnGivenConfig } from '@streaming-projects/utils';
import { useFormikContext } from 'formik';

import { TABLEFLOW_WORKLOAD_DETAILS_CONFIG } from '../config';
import { useSPTableFlowContext } from '../contexts/SPTableFlowWorkloadContextProvider';

import { SPTableFlowWorkloadNameContainer } from './SPTableFlowWorkloadNameContainer';

export const SPTableFlowWorkloadDetailsContainer = () => {
  const { orgId, spId, tableFlowWorkloadId } = useParams();
  const { values, initialValues } = useFormikContext();
  const [updateTableFlowWorkload] = useUpdateTableFlowWorkloadMutation();
  const spStreamingProjectData = useContext(SPStreamingProjectContext);
  const spTableFlowWorkloadData = useSPTableFlowContext();

  const shouldFormBeDisabled = isAnythingEditedBesidesGivenFormBasedOnGivenConfig(
    initialValues,
    values,
    TABLEFLOW_WORKLOAD_DETAILS_CONFIG,
    FORM_NAMES.TABLE_FLOW.WORKLOAD_DETAILS_FORM
  );

  return (
    <PaddedAndRaisedSegment disabled={shouldFormBeDisabled}>
      <GenericSaveResetButtons
        fieldsConfig={TABLEFLOW_WORKLOAD_DETAILS_CONFIG.filter(
          (x) => x.belongingForm === FORM_NAMES.TABLE_FLOW.WORKLOAD_DETAILS_FORM
        )}
        onSaveHandler={async ({
          name,
          retention_days: retentionDays,
          retention_infinite: retentionInfinite,
        }) => {
          return await updateTableFlowWorkload({
            orgId,
            spId,
            tableFlowWorkloadId,
            payload: {
              name,
              inputs: {
                retention: {
                  retention_days: retentionDays,
                  is_finite_retention: !retentionInfinite,
                },
              },
              tableflow_resource_id: spTableFlowWorkloadData?.tableflow_resource_id,
              sp_version: spStreamingProjectData?.sp?.version,
            },
          });
        }}
      />
      <Spacer y={20} />
      <Grid>
        <Grid.Row>
          <Grid.Column width={4}>
            <SPTableFlowWorkloadNameContainer disabled={false} />
          </Grid.Column>
          <Grid.Column width={4}>
            <SPRetentionContainer />
            <RetentionApprovalRequiredContainer isCustomerViewEnabled={false} />
          </Grid.Column>
          <Grid.Column width={4}>
            <SPRetentionInfiniteContainer />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </PaddedAndRaisedSegment>
  );
};
